export const applications = {
  "Animal health" : [
    'Other',
    'Tablet',
    'Capsule',
    'Sachet',
    'Paste'
  ],
  "Bakery": [
    "Biscuit" ,
    "Bread" ,
    "Cake & Brioche" ,
    "Cooked croissant" ,
    "Cooked puff pastry" ,
    "Frozen croissant" ,
    "Frozen puff pastry" ,
    "Patisserie/dessert" ,
    "Ready-to-use dough"
  ],

  "Confectionary" : [
    "Candied Chocolate",
    "Chocolate"
  ],
  "Dairy" : [
    "Cheese",
    "Cream",
    "Dessert",
    "Milk",
    "Yogurt"
  ],
  "Dairy-like" : [
    "Cheese",
    "Cream",
    "Dessert",
    "Milk",
    "Yogurt",
  ],
  "Distributor" : [
    "B2B",
    "Retail"
  ],
  "Drink" : [
    "Alcoholic",
    "Non-alcoholic",
    "Other"
  ],
  "Feed" : [
    "Farming",
    "Feed Ingredient",
    "Petfood"
  ],
  "Filling" : [
    "Filling"
  ],
  "Flavor" : [
    "Flavor extractor",
    "Flavor formulator"
  ],
  "Food Ingredient" : [
    "Food Ingredient"
  ],
  "Human health" : [
    "Other",
    "Pharmaceutical",
    "Tablet",
    "Capsule",
    "Sachet",
    "Inhalation"
  ],
  "Ice Cream" : [
    "Ice Cream retail",
    "Premix"
  ],
  "Oils & Fats" : [
    "B2B Margerine",
    "B2C Margerine"
  ],
  "Other" : [
    "Other"
  ],
  "Other pharma" : [
    "Other Pharma"
  ],
  "QSR" : [
    "QSR"
  ],
  "Ready meal" : [
    "Prepared food",
    "Sandwich",
    "Salty puff party"
  ],
  "Snack" : [
    "Savoury snack",
    "Sweet snack",
    "Snack"
  ],
  "Spread" : [
    "Savoury spread",
    "Sweet spread"
  ],
  "Pet" : [
    "Petfood",
    "Petcare"
  ],
  "Bevarage" : [
    "Other",
    "Non dairy Creamer",
    "Coconut drink"
  ],
  "Meat" : [
    "Ready meals",
    "Sea product"
  ],
  "Trader" : [
    "Blend",
    "Other"
  ],
  "Blender" : [
    "Blend"
  ],
  "Infant" : [
    "Powder",
    "Liquid",
    "Enteral",
    "Fortifier"
  ],
  "Clinical" : [
    "Other",
    "Powder",
    "Enteral",
    "Parenteral",
    "Beverage",
    "Pudding"
  ],
  "Sport and Diet" : [
    "Other",
    "Powders",
    "Bars",
    "Snack",
    "Beverage"
  ],
  "Food Supplement" : [
    "Other",
    "Tablet",
    "Capsule",
    "Sachet"
  ],
  "Senior" : [
    "Other",
    "Powders",
    "Beverage"
  ],
  "Technical" : [
    "Technical"
  ],
  "Cosmetic" : [
    "Cosmetic"
  ],
  "Phytosanitary" : [
    "Crops"
  ]
}
